import { SpendTypeEnum } from 'components/Classification';
import { PERMISSIONS } from 'utils/constants';

interface IConfigItem {
  path: string;
  name: string;
  permission?: string;
}

export const ROOT_ROUTE = '/productallocation';

export const CONFIG = [
  {
    path: `${ROOT_ROUTE}/${SpendTypeEnum.THIRD_PARTY}`,
    name: SpendTypeEnum.THIRD_PARTY,
  },
  {
    path: `${ROOT_ROUTE}/${SpendTypeEnum.PERSONNEL}`,
    name: SpendTypeEnum.PERSONNEL,
    permission: PERMISSIONS.PRODUCTS_DATA_ALLOCATE,
  },
] as IConfigItem[];
